import { get } from 'lodash';
import { isNumber } from 'util';

import * as ValidateActions from '../actions/validate';
import { ValidationResponseModel } from '../../shared/models/validation-response.model';
import { createHotelValidationCacheId } from '../../../../shared/help/functions';

export class StateObject {
	inProgress: boolean;
	response: ValidationResponseModel;
	xml: string;
	error?: string;
	id?: string;
}

export class State {
	[s: string]: StateObject;
}

export const InitialState: State = {};

export function reducer(state: State = InitialState, action: ValidateActions.All): State {
	switch (action.type) {
		case ValidateActions.VALIDATE_SUCCESS:
			const hotelId = createHotelValidationCacheId(action.offer);
			const transportId = action.offer.id.substr(32);

			const newState = {
				...state,
				[action.offer.id]: {inProgress: false, response: action.payload, xml: ''},
			};

			if (!isNumber(get(newState[action.offer.id], 'response.totalPrice', null))) {
				newState[action.offer.id].response.totalPrice = parseFloat(get(newState[action.offer.id], 'response.totalPrice', NaN));
			}

			if (get(action, 'payload.hints', []).includes('BOOKED_UP_FLIGHT')) {
				newState[`transport:${transportId}`] = {inProgress: false, response: {...action.payload, id: transportId}, xml: ''};
			}

			if (get(action, 'payload.hints', []).includes('BOOKED_UP_HOTEL')) {
				newState[`hotel:${hotelId}`] = {inProgress: false, response: {...action.payload, id: hotelId}, xml: ''};
			}

			return newState;

		case ValidateActions.VALIDATE_ERROR:
			return {...state, [action.id]: {inProgress: false, response: null, xml: '', error: action.message}};

		case ValidateActions.VALIDATE:
			return {...state, [action.payload.id]: {inProgress: true, response: null, xml: ''}};

		case ValidateActions.GET_CRS_XML_SUCCESS:
			return {...state, [action.id]: {inProgress: state[action.id].inProgress, response: state[action.id].response, xml: action.payload.crs}};

		default:
			return state;
	}
}

export const GetValidationsInProgress = (state: State): Array<StateObject> => Object.keys(state).map(id => {
	return { ...state[id], id: id };
}).filter(s => s.inProgress);



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/validate.ts